export default "__VITE_ASSET__DBLGw1Ut__"